import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

import {
  WrapperStyled,
  TextStyled,
  ButtonsStyled,
} from './styles/ServiceErrorStyled';

import { ReactComponent as GhostIcon } from '../../../images/ui/ghost-error-icon.svg';

const ServiceError = ({ retryCallback }) => {
  return (
    <WrapperStyled>
      <GhostIcon />
      <TextStyled>
        <h3>No disponible</h3>
        <p>
          Nuestro sistema ha fallado. Reintenta cargar tu información en los
          próximos minutos
        </p>
      </TextStyled>
      <ButtonsStyled>
        <Button
          color="purple"
          outline
          maxWidth="300px"
          width="100%"
          margin="0 0 20px 0"
          click={retryCallback}
        >
          REINTENTAR
        </Button>
      </ButtonsStyled>
    </WrapperStyled>
  );
};

ServiceError.propTypes = {
  retryCallback: PropTypes.func.isRequired,
};

export default ServiceError;
